import React from 'react';
import { adminProductApi } from '../../../../api/adminProductApi';
import MobileProductDialog from './MobileProductDialog';
import MobileProductFeedback from './MobileProductFeedback';
import useMobileMutation from './useMobileMutation';

export default function MobileDeactivateProduct({ product, onSaved, onClose }) {
  const mutation = useMobileMutation();
  return (
    <MobileProductDialog
      size='compact'
      title='Деактивувати товар?'
      subtitle={`#${product.id} · ${product.name}`}
      busy={mutation.busy}
      onClose={onClose}
      onSubmit={() =>
        mutation.run(
          () => adminProductApi.deleteProduct(product.id),
          () => {
            onSaved('Товар деактивовано');
            onClose();
          },
        )
      }
      footer={
        <>
          <button
            type='button'
            className='btn btn-outline-secondary'
            disabled={mutation.busy}
            onClick={onClose}
          >
            Скасувати
          </button>
          <button type='submit' className='btn btn-danger' disabled={mutation.busy}>
            {mutation.busy ? 'Збереження…' : 'Деактивувати'}
          </button>
        </>
      }
    >
      <MobileProductFeedback error={mutation.error} />
      <p>
        Товар стане неактивним. Його можна буде знайти за відповідним статусом і знову активувати.
      </p>
    </MobileProductDialog>
  );
}
